export default __webpack_public_path__ + "static/media/post_walt.ea2fce57.jpg";